import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTurkey = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "121px",
	height: "120px",
	viewBox: "0 0 121 120",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Group 27" }),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("polygon", {
				id: "path-1",
				points: "0 0 42 0 42 34.89105 0 34.89105"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				id: "path-3",
				points: "0 0 37.81425 0 37.81425 57.177 0 57.177"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				id: "path-5",
				points: "0 0 37.81425 0 37.81425 57.177 0 57.177"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				id: "path-7",
				points: "0 120 120 120 120 0 0 0"
			})
		] }),
		/* @__PURE__ */ _jsx("g", {
			id: "Thanksgiving",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				transform: "translate(-452.000000, -140.000000)",
				id: "Group-2",
				children: /* @__PURE__ */ _jsx("g", {
					transform: "translate(174.500000, 140.000000)",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Group-27",
						transform: "translate(278.000000, 0.000000)",
						children: [
							/* @__PURE__ */ _jsxs("g", {
								id: "Group-3",
								transform: "translate(38.999250, 0.000000)",
								children: [
									/* @__PURE__ */ _jsx("mask", {
										id: "mask-2",
										fill: "white",
										children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#path-1" })
									}),
									/* @__PURE__ */ _jsx("g", { id: "Clip-2" }),
									/* @__PURE__ */ _jsx("path", {
										d: "M36.75,34.89105 L32.2515,30.92205 C34.6695,28.18155 36,24.65955 36,20.99955 C36,12.73005 29.2725,5.99955 21,5.99955 C12.729,5.99955 6,12.73005 6,20.99955 C6,24.65955 7.332,28.18155 9.75,30.92205 L5.2515,34.89105 C1.866,31.05555 0,26.12205 0,20.99955 C0,9.42105 9.4215,-0.00045 21,-0.00045 C32.58,-0.00045 42,9.42105 42,20.99955 C42,26.12205 40.1355,31.05555 36.75,34.89105",
										id: "Fill-1",
										fill: "currentcolor",
										mask: "url(#mask-2)"
									})
								]
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M60,25.5 C53.3835,25.5 48,30.8835 48,37.5 C48,40.4265 49.065,43.245 51,45.4365 C53.2785,48.0195 56.559,49.5 60,49.5 C63.441,49.5 66.7215,48.0195 69,45.4365 C70.935,43.245 72,40.4265 72,37.5 C72,30.8835 66.6165,25.5 60,25.5 M60,55.5 C54.8385,55.5 49.917,53.28 46.5,49.407 C43.5975,46.119 42,41.8905 42,37.5 C42,27.5745 50.0745,19.5 60,19.5 C69.9255,19.5 78,27.5745 78,37.5 C78,41.8905 76.4025,46.119 73.5,49.407 C70.083,53.28 65.1615,55.5 60,55.5",
								id: "Fill-4",
								fill: "currentcolor"
							}),
							/* @__PURE__ */ _jsxs("g", {
								id: "Group-8",
								transform: "translate(0.000000, 33.712200)",
								children: [
									/* @__PURE__ */ _jsx("mask", {
										id: "mask-4",
										fill: "white",
										children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#path-3" })
									}),
									/* @__PURE__ */ _jsx("g", { id: "Clip-7" }),
									/* @__PURE__ */ _jsx("path", {
										d: "M34.18575,57.177 L6.15075,35.8485 C2.18475,31.884 -0.00075,26.61 -0.00075,21 C-0.00075,15.3915 2.18475,10.1175 6.15075,6.1515 C10.11675,2.1855 15.39075,0 20.99925,0 L20.99925,6 C16.99425,6 13.22625,7.56 10.39425,10.395 C7.56075,13.227 5.99925,16.9935 5.99925,21 C5.99925,24.942 7.50975,28.6515 10.25625,31.467 L37.81425,52.398 L34.18575,57.177 Z",
										id: "Fill-6",
										fill: "currentcolor",
										mask: "url(#mask-4)"
									})
								]
							}),
							/* @__PURE__ */ _jsxs("g", {
								id: "Group-11",
								transform: "translate(82.185750, 33.712200)",
								children: [
									/* @__PURE__ */ _jsx("mask", {
										id: "mask-6",
										fill: "white",
										children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#path-5" })
									}),
									/* @__PURE__ */ _jsx("g", { id: "Clip-10" }),
									/* @__PURE__ */ _jsx("path", {
										d: "M3.6285,57.177 L0,52.398 L27.558,31.467 C30.3045,28.6515 31.815,24.942 31.815,21 C31.815,16.9935 30.2535,13.227 27.4215,10.395 C24.588,7.56 20.82,6 16.815,6 L16.815,0 C22.4235,0 27.6975,2.1855 31.6635,6.1515 C35.6295,10.1175 37.815,15.3915 37.815,21 C37.815,26.61 35.6295,31.884 31.6635,35.8485 L31.356,36.117 L3.6285,57.177 Z",
										id: "Fill-9",
										fill: "currentcolor",
										mask: "url(#mask-6)"
									})
								]
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M74.95905,66.51855 L71.31255,61.75455 L93.23955,44.97255 C98.95455,39.11205 98.90955,29.69655 93.10755,23.89305 C89.37105,20.15805 83.86755,18.65805 78.74655,19.97355 L77.25255,14.16405 C84.41805,12.31155 92.11905,14.42055 97.34955,19.65105 C105.53655,27.83955 105.53655,41.16105 97.34955,49.34955 L97.05105,49.61055 L74.95905,66.51855 Z",
								id: "Fill-12",
								fill: "currentcolor"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M45.04095,66.51855 L22.65045,49.34955 C14.46345,41.16105 14.46345,27.83955 22.65045,19.65105 C27.87945,14.42505 35.57895,12.31755 42.74745,14.16405 L41.25345,19.97355 C36.13095,18.65955 30.62895,20.15805 26.89245,23.89305 C21.09045,29.69655 21.04545,39.11205 26.76045,44.97255 L48.68745,61.75455 L45.04095,66.51855 Z",
								id: "Fill-14",
								fill: "currentcolor"
							}),
							/* @__PURE__ */ _jsx("polygon", {
								id: "Fill-16",
								fill: "currentcolor",
								points: "74.9883 46.10445 72.0123 40.89495 77.9538 37.50045 72.0123 34.10445 74.9883 28.89495 90.0468 37.50045"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M63,37.5 C63,39.1575 61.6575,40.5 60,40.5 C58.3425,40.5 57,39.1575 57,37.5 C57,35.8425 58.3425,34.5 60,34.5 C61.6575,34.5 63,35.8425 63,37.5",
								id: "Fill-18",
								fill: "currentcolor"
							}),
							/* @__PURE__ */ _jsx("mask", {
								id: "mask-8",
								fill: "white",
								children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#path-7" })
							}),
							/* @__PURE__ */ _jsx("g", { id: "Clip-21" }),
							/* @__PURE__ */ _jsx("polygon", {
								id: "Fill-20",
								fill: "currentcolor",
								mask: "url(#mask-8)",
								points: "57.003 59.784 63.003 59.784 63.003 50.784 57.003 50.784"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M60,63 C47.5935,63 37.5,73.0935 37.5,85.5 C37.5,97.9065 47.5935,108 60,108 C72.4065,108 82.5,97.9065 82.5,85.5 C82.5,73.0935 72.4065,63 60,63 M60,114 C44.2845,114 31.5,101.2155 31.5,85.5 C31.5,69.7845 44.2845,57 60,57 C75.7155,57 88.5,69.7845 88.5,85.5 C88.5,101.2155 75.7155,114 60,114",
								id: "Fill-22",
								fill: "currentcolor",
								mask: "url(#mask-8)"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M99,105 L78,105 L78,99 L99,99 C107.271,99 114,92.271 114,84 C114,79.185 111.663,74.6295 107.748,71.8125 L111.252,66.9435 C116.73,70.884 120,77.2605 120,84 C120,95.58 110.58,105 99,105",
								id: "Fill-23",
								fill: "currentcolor",
								mask: "url(#mask-8)"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M42,105 L21,105 C9.42,105 0,95.58 0,84 C0,77.2605 3.27,70.884 8.748,66.9435 L12.252,71.8125 C8.337,74.6295 6,79.185 6,84 C6,92.271 12.729,99 21,99 L42,99 L42,105 Z",
								id: "Fill-24",
								fill: "currentcolor",
								mask: "url(#mask-8)"
							}),
							/* @__PURE__ */ _jsx("polygon", {
								id: "Fill-25",
								fill: "currentcolor",
								mask: "url(#mask-8)",
								points: "52.5 120 58.5 120 58.5 109.5 52.5 109.5"
							}),
							/* @__PURE__ */ _jsx("polygon", {
								id: "Fill-26",
								fill: "currentcolor",
								mask: "url(#mask-8)",
								points: "61.5 120 67.5 120 67.5 109.5 61.5 109.5"
							})
						]
					})
				})
			})
		})
	]
});
export default SvgTurkey;
